import { Category } from './types';

export const CATEGORY_COLORS = ['#60a5fa', '#4ade80', '#f472b6', '#fbbf24', '#a78bfa', '#fb7185', '#2dd4bf', '#f97316'];
export const TAG_COLORS = ['#f472b6', '#4ade80', '#60a5fa', '#fbbf24', '#a78bfa', '#fb7185', '#2dd4bf', '#f97316'];

export function colorForIndex(index: number, palette = CATEGORY_COLORS) {
  return palette[index % palette.length];
}

export function colorForCategory(category: Category, index: number, categories: Category[]) {
  if (!category.color) return colorForIndex(index);
  return category.color;
}
